<template>
  <div style="position: relative;" class="bg-white pl-4 pt-4 rounded">
    <div>
      <div class="d-flex justify-content-between" style="margin-bottom: 1.70rem;">
        <div class="d-flex align-items-center" style="gap: 2.34rem;">
          <div>
            <h1 class="title">{{ $t("risk.organization") }}</h1>
          </div>
          <div class="search2">
            <div class="search2--icon"><i class="iconoir-search"></i></div>
            <input v-model="nameFilter" class="search2--input" type="text" :placeholder="$t('common.search')" />
          </div>
        </div>

        <b-dropdown v-if="this.currentProduct" split split-href="#" :text="$t('task.download-options')" size="sm" variant="light" class="m-2">
          <b-dropdown-item @click="downloadExcel" href="#">{{ $t("common.download") }}</b-dropdown-item>
        </b-dropdown>

        <right-panel class="float-right" id="sidebar-add-new-risk" width="1300px" :icon="'mdi mdi-plus'" @hidden="rightPanelClosed">
          <div class="pl-5 pr-5">
            <organizationRiskAddLibraryForm :product="currentProduct || 'PLATFORM'" />
          </div>
        </right-panel>

        <a v-if="(hasRiskAdminPermission && this.currentProduct) || hasDepartmentAndProcessAdminPermission" @click="$root.$emit('bv::toggle::collapse', 'sidebar-add-new-risk')">
          <div class="d-flex align-items-center">
            <div class="new-task-text">{{ $t("risk.new") }}</div>
            <div class="plus-button" style="margin-right: 1.56rem;"></div>
          </div>
        </a>
      </div>
      <nav class="tab-menu">
        <!-- <div :class="{ active: activeTab === 'rating' }" @click="activeTab = 'rating'">
          {{ $t("risk.recommendation") }}
        </div> -->
        <div
          :class="{ active: activeTab === 'organizationRisk' }"
          @click="
            activeTab = 'organizationRisk';
            activeSubTab = 'prevention';
          "
        >
          {{ $t("risk.organization") }}
        </div>

        <div :class="{ active: activeTab === 'approval' }" @click="activeTab = 'approval'">{{ $t("risk.approval.my") }}</div>
        <!-- <div v-if="hasViewUnworkedRiskPermission" :class="{ active: activeTab === 'unworked' }" @click="activeTab = 'unworked'">{{ $t("risk.unworked") }}</div> -->
      </nav>
      <div class="mt-4">
        <content-loading v-if="isLoading" />
        <div class="mb-4" v-if="activeTab == 'organizationRisk'">
          <nav class="tab-menu">
            <!-- <div :class="{ active: activeSubTab === 'rating' }" @click="activeSubTab = 'rating'">
              {{ $t("risk.recommendation") }}
            </div> -->
            <div :class="{ active: activeSubTab === 'prevention' }" @click="activeSubTab = 'prevention'">{{ $t("risk.prevention") }}</div>
            <div :class="{ active: activeSubTab === 'inactive' }" @click="activeSubTab = 'inactive'">{{ $t("risk.status.inactive") }}</div>
          </nav>
        </div>
        <empty v-if="!isLoading && (!pagination || pagination.docs.length == 0)" width="200px">
          <h5 class="text-center">
            {{ $t("common.no-data") }}
          </h5>
        </empty>
        <div v-if="!isLoading && pagination && pagination.docs.length > 0" class="rcontainer">
          <!---->
          <div class="rcard" v-for="risk in pagination.docs" :key="risk._id">
            <div class="d-flex align-items-center justify-content-between mb-4">
              <div class="rtitle hand" @click="edit(risk._id)">{{ risk.name | translate }}</div>
              <div class="pcard--actions">
                <i class="iconoir-page hand" @click="redirectToRelatedFiles(risk)" v-on:click.stop v-b-tooltip.hover :title="$t('file-manager.view-related-files')"></i>
                <i class="iconoir-edit" @click="edit(risk._id)"></i>
                <i class="iconoir-trash" @click="deleteById(risk._id)"></i>
              </div>
            </div>

            <div class="rdefinition">{{ $t("risk.threat-definition.text") }}</div>
            <div class="rdescription">{{ stringify(risk.threats) }}</div>
            <div class="rdefinition">{{ $t("risk.weakness-definition.text") }}</div>
            <div class="rdescription">{{ stringify(risk.weaknesses) }}</div>

            <div class="rdefinition">{{ $t("risk.category.text") }}</div>
            <div class="rdescription"><risk-category-badge :risk="risk" /></div>

            <div class="rflex-row">
              <div>
                <div class="icon text-white"><i class="iconoir-shield-alert"></i></div>
                {{ $t("risk.possibility") }}
              </div>
              <div>{{ risk.possibility }}</div>
            </div>
            <hr />
            <div class="rflex-row">
              <div>
                <div class="icon text-white"><i class="iconoir-shield-alert"></i></div>
                {{ $t("risk.effect") }}
              </div>
              <div>{{ risk.effectValue }}</div>
            </div>
            <hr />
            <div class="rflex-row text-white">
              <div>
                <div class="icon text-white"><i class="iconoir-shield-alert"></i></div>
                {{ $t("risk.risk-point") }}
              </div>
              <div>{{ risk.appliedRiskPoint }}</div>
            </div>

            <applied-risk-value-badge v-if="risk.appliedRiskValue" :risk="risk" />
          </div>
          <!---->
        </div>

        <div v-if="pagination" class="row">
          <div class="col">
            <ul class="pagination pagination-rounded mb-0">
              <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppliedRiskValueBadge from "./component/applied-risk-value-badge";
import RiskCategoryBadge from "./component/risk-category-badge";
import organizationRiskAddLibraryForm from "./organization-risk-add-library-form.vue";

export default {
  components: { AppliedRiskValueBadge, RiskCategoryBadge, organizationRiskAddLibraryForm },
  data() {
    return {
      request: {
        options: { page: 1, limit: 9, sort: { name: "asc" } },
        query: {},
      },
      nameFilter: undefined,
    };
  },

  computed: {
    activeTab: {
      get() {
        return this.$store.getters["organizationRisk/selectedTab"];
      },
      set(v) {
        this.$store.commit("organizationRisk/selectedTab", v);
      },
    },
    activeSubTab: {
      get() {
        return this.$store.getters["organizationRisk/selectedSubTab"];
      },
      set(v) {
        this.$store.commit("organizationRisk/selectedSubTab", v);
      },
    },
    pagination() {
      return this.$store.getters["organizationRisk/pagination"];
    },
    isLoading() {
      return this.$store.getters["organizationRisk/isLoading"];
    },
    hasRiskAdminPermission() {
      return this.currentAccountHasPermissions([
        "ORGANIZATION_RISK_ADMIN",
        "ORGANIZATION_LEGAL_ADMIN",
        "ORGANIZATION_GDPR_PRODUCT_ADMIN",
        "ORGANIZATION_KVKK_PRODUCT_ADMIN",
        "ORGANIZATION_BGYS_PRODUCT_ADMIN",
        "ORGANIZATION_DDO_PRODUCT_ADMIN",
      ]);
    },
    hasDepartmentAndProcessAdminPermission() {
      return this.currentAccountHasPermissions([
        "ORGANIZATION_GDPR_ACCESS",
        "ORGANIZATION_KVKK_ACCESS",
        "ORGANIZATION_BGYS_ACCESS",
        "ORGANIZATION_DDO_ACCESS",
        "ORGANIZATION_RISK_ACCESS",
      ]);
    },
    hasViewUnworkedRiskPermission() {
      return this.currentAccountHasPermissions(["ORGANIZATION_RISK_ADMIN"]);
    },
    hasApprovalPermission() {
      return this.currentAccountHasPermissions([
        "ORGANIZATION_KVKK_PRODUCT_ADMIN",
        "ORGANIZATION_DDO_PRODUCT_ADMIN",
        "ORGANIZATION_BGYS_PRODUCT_ADMIN",
        "ORGANIZATION_GDPR_PRODUCT_ADMIN",
        "ORGANIZATION_INFORMATION_TECHNOLOGY_ADMIN",
        "ORGANIZATION_RISK_ADMIN",
        "ORGANIZATION_LEGAL_ADMIN",
      ]);
    },
  },

  watch: {
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.paginate());
      },
    },

    nameFilter(n, o) {
      if (n) {
        this.request.query = { ...this.request.query, name: { value: n } };
      } else {
        this.request.query["name"] = null;
        delete this.request.query["name"];
      }
    },

    activeTab(n, o) {
      this.paginate();
    },
    activeSubTab(n, o) {
      this.paginate();
    },
  },
  mounted() {
    this.handleQueryParams();
  },
  methods: {
    stringify(arr) {
      return arr?.map((a) => a.name[this.currentLanguage]).join(", ") || "";
    },
    rightPanelClosed() {
      this.$store.commit("organizationRisk/reset");
      this.$store.commit("organizationRisk/copingEntity", undefined);
      this.$store.commit("organizationRisk/editedEntity", undefined);
      this.$store.commit("organizationRisk/risk", undefined);
      this.paginate();
    },
    redirectToRelatedFiles(item) {
      const url = this.currentProduct ? `/${this.currentProduct.toLowerCase()}/file-manager` : "/organization/file-manager";
      this.$router.push({
        path: url,
        query: { risk: item._id, riskName: item.name?.[this.currentLanguage] },
      });
    },
    async paginate() {
      const tmprequest = JSON.parse(JSON.stringify(this.request));
      delete tmprequest.query["acceptance"];
      delete tmprequest.query["approval.status"];
      delete tmprequest.query["approval.assignee"];

      if (this.activeTab == "unworked") {
        this.activeSubTab = null;
        delete tmprequest.query.status;
        tmprequest.query["acceptance"] = { value: "UNWORKED", isObject: true };
      } else if (this.activeTab == "approval") {
        this.activeSubTab = null;
        delete tmprequest.query.status;
        tmprequest.query["approval.status"] = { value: "PENDING", isObject: true };
        tmprequest.query["approval.assignee"] = { value: this.currentAccount._id, isObject: true };
      } else if (this.activeTab == "organizationRisk") {
        // if (this.activeSubTab == "rating") {
        //   tmprequest.query["status"] = { value: "RATING", isObject: true };
        //}
        if (this.activeSubTab == "prevention") {
          tmprequest.query["status"] = { value: "ACTIVE", isObject: true };
        } else if (this.activeSubTab == "inactive") {
          tmprequest.query["status"] = { value: "INACTIVE", isObject: true };
        }
      }
      if (this.currentProduct) {
        tmprequest.query = { ...tmprequest.query, products: { value: this.currentProduct, isObject: true } };
      }
      await this.$store.dispatch("organizationRisk/paginate", tmprequest);
    },

    edit(id) {
      this.$store.commit("organizationRisk/isEditing", true);
      this.$store.commit("organizationRisk/riskId", id);

      this.$router.push(`/${this.currentProduct ? this.currentProduct.toLowerCase() : "organization"}/risk-detail/${id}`);
    },
    handleQueryParams() {
      const queryParams = this.$route.query;

      const safeActiveTabs = ["approval"];

      if (!queryParams) {
        return;
      }

      if (queryParams.activeTab && safeActiveTabs.includes(queryParams.activeTab)) {
        this.activeTab = queryParams.activeTab;
      }
    },

    async deleteById(id) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`organizationRisk/delete`, id);
        this.paginate();
        this.$toast.success(this.$t("common.delete-successful"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    }, //
    async download(item) {
      this.$store.commit("fileManager/addDownloadedFile", { file: item });
    },

    async downloadExcel() {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        const payload = { organization: { _id: this.currentOrganization?._id, name: this.currentOrganization?.name } };

        if (this.activeTab == "approval") {
          payload.downloadScope = "ACCOUNT_IN_ORGANIZATION";
        } else if (this.activeTab == "unworked") {
          payload.downloadScope = "UNWORKED_IN_ORGANIZATION";
        }
        payload.product = this.currentProduct;

        const { data: file } = await this.$store.dispatch(`organizationRisk/download`, payload);
        this.download(file);

        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error, { timeout: 5000 });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./organization-risk-view.scss";
</style>
